import { forwardRef } from "react";
import { ReactComponent as GarageHomeSvg } from "imgs/GarageHome.svg";
import type { SvgIconProps } from "@mui/material/SvgIcon";

const GarageHomeIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <GarageHomeSvg
    ref={ref}
    {...props}
    fill="currentColor"
    stroke="currentColor"
  />
));

export default GarageHomeIcon;
